module.exports = __webpack_public_path__ + "static/img/roberto-nickson-IOI3KCYsn0o-unsplash_thumb.cbb88aa.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/roberto-nickson-IOI3KCYsn0o-unsplash_thumb.png
// module id = L52e
// module chunks = 4